export enum ButtonTypeJobPlan {
  OPTIMIZED = 'optimized',
  LOAD_MANAGEMENT = 'load-management',
  JOB_SUMMARY = 'job-summary',
  LOAD_ASSIGNMENT = 'load-assignment',
  SCHEDULE = 'schedule',
  NONE = 'none',
}